import Accordion from 'components/Accordion'
import { Link } from 'components/Link'
import IconArrowRight from 'components/partials/IconArrowRight'
import ViewModeContext from 'contexts/ViewModeContext'
import React from 'react'
import { useTranslation } from 'react-i18next'
import useClickLogger from '../../../../api/ClickLogger'
import { cleanString } from '../../../../helpers/string'

/**
 * This file is for both syllabus and reading list
 */

function SyllabusTemplate({ ...doc }) {
  const { t, i18n } = useTranslation()

  const mutateFields = {
    academic_credits(value) {
      value = Number(value).toFixed(value % 1 === 0 ? 0 : 1)
      value = i18n.language !== 'sv' ? value : value.replace(/\./, ',')
      value = `${value} ${t('suffix.academic_credits')}`
      return value
    },
    syllabuses(list) {
      return [].concat(list)
    },
    reading_lists(list) {
      return [].concat(list)
    },
  }

  Object.values(mutateFields).forEach((fieldFn) => {
    if (doc.hasOwnProperty(fieldFn.name))
      doc[fieldFn.name] = fieldFn(doc[fieldFn.name])
  })

  doc.__breadcrumb__ = [
    { displayName: t('Home'), url: '/' },
    { displayName: t('Study') },
  ]

  return (
    <ViewModeContext.Consumer>
      {(context) => <SyllabusTeaser {...doc} />}
    </ViewModeContext.Consumer>
  )
}

export default SyllabusTemplate

function SyllabusTeaser({
  title,
  _click,
  url,
  type,
  education_course_code,
  reading_lists = [],
  syllabuses = [],
}) {
  const { t } = useTranslation()
  const { trackResultClick } = useClickLogger(_click, url)

  function SyllabusTable(content, educationType) {
    if (content.length != null && typeof content !== 'undefined') return null
    if (content.educationType == null || content.educationType == undefined)
      return null

    function LinkIcon({ url, title }) {
      switch (true) {
        case url === null || url === undefined:
          return null
        case title.includes('(pdf)'):
          return null
        case url.includes('kursplaner.gu.se'):
          return '(pdf)'
        case url.includes('se/sites/default/files'):
          return '(pdf)'
        default:
          return <IconArrowRight />
      }
    }
    // Check if syllabuses is usable as array
    const syllabusTitle =
      content.type === 'syllabus' ? 'syllabus' : 'reading_list'
    let syllabusTransContext = 'programme'
    if (!Array.isArray(content.educationType)) {
      switch (content.educationType.toLowerCase()) {
        case 'kurs' || 'kurspaket':
          syllabusTransContext = 'course'
          break
        case 'program' || 'programinriktning':
          syllabusTransContext = 'programme'
          break
      }
    }

    return (
      <table className="syllabus-table">
        <thead className="syllabus-table__head">
          <tr>
            <th className="syllabus-table__head--title">
              {t(syllabusTitle, { context: syllabusTransContext })}
            </th>
            <th className="syllabus-table__head--date">{t('syllabus_date')}</th>
          </tr>
        </thead>
        <tbody className="syllabus-table__body">
          {content.content.map((hit) => {
            if (hit.title === null && hit.url === null) {
              return null
            }
            return (
              <tr>
                <td className="syllabus-table__body--title">
                  <Link href={hit.url}>
                    {hit.title} <LinkIcon url={hit.url} title={hit.title} />
                  </Link>
                </td>
                <td className="syllabus-table__body--date">
                  {hit.date_text !== null
                    ? hit.date_text
                    : hit.date !== null
                      ? hit.date
                      : '-'}
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    )
  }
  function Headings() {
    return (
      <div className="syllabuses__table--row">
        <div className="syllabuses__table--col">{cleanString(title)}</div>
        <div className="syllabuses__table--col">
          {Array.isArray(type) ? type.map((item) => `${item} `) : type}
        </div>
        <div className="syllabuses__table--col">{education_course_code}</div>
      </div>
    )
  }
  return (
    <div className="syllabus-table__wrapper">
      <Accordion headerChildren={<Headings />}>
        {syllabuses.length > 0 ? (
          <SyllabusTable
            content={syllabuses}
            type="syllabus"
            educationType={type}
          />
        ) : null}
        {reading_lists.length > 0 ? (
          <SyllabusTable
            content={reading_lists}
            type="reading_list"
            educationType={type}
          />
        ) : null}
      </Accordion>
    </div>
  )
}
